




import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    equipmentCount: 0,
    routesCount: 0,
    vesselsCount: 0,
    portsCount: 0,
    schedulesCount: 0,
    enquiriesCount: 0
  });

  useEffect(() => {
    // Check if user is logged in
    const isAdmin = sessionStorage.getItem('isAdmin');
    if (isAdmin !== 'true') {
      navigate('/login');
      return;
    }

    // Fetch dashboard statistics
    fetchDashboardStats();
  }, [navigate]);

  const fetchDashboardStats = async () => {
    setLoading(true);
    try {
      // Fetch data in parallel
      const [equipmentRes, routesRes, vesselsRes, portsRes, schedulesRes] = await Promise.all([
        axios.get('https://ecl.net.in/backende/api/equipment'),
        axios.get('https://ecl.net.in/backende/api/sailing-routes'),
        axios.get('https://ecl.net.in/backende/api/vessels'),
        axios.get('https://ecl.net.in/backende/api/ports'),
        axios.get('https://ecl.net.in/backende/api/schedules')
      ]);

      // Try to fetch enquiries if available
      let enquiriesCount = 0;
      try {
        const enquiriesRes = await axios.get('https://ecl.net.in/backende/api/enquiries');
        enquiriesCount = enquiriesRes.data.length;
      } catch (error) {
        console.log('Enquiries endpoint might not be available');
      }

      setStats({
        equipmentCount: equipmentRes.data.length,
        routesCount: routesRes.data.length,
        vesselsCount: vesselsRes.data.length,
        portsCount: portsRes.data.length,
        schedulesCount: schedulesRes.data.length,
        enquiriesCount: enquiriesCount
      });
      setLoading(false);
    } catch (err) {
      console.error("Error fetching dashboard stats:", err);
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <p className="welcome-message">Welcome to ECL Shipping Admin Panel</p>
      </div>

      {loading ? (
        <div className="dashboard-loading">
          <div className="dashboard-spinner"></div>
          <p>Loading dashboard data...</p>
        </div>
      ) : (
        <div className="dashboard-content">
          <div className="dashboard-cards">
            <div className="dashboard-card" onClick={() => navigate('/admin/equipment')}>
              <div className="card-icon equipment-icon">
                <i className="fas fa-tools"></i>
              </div>
              <div className="card-content">
                <h3>Equipment</h3>
                <p className="stat-count">{stats.equipmentCount}</p>
                <p className="stat-label">Total Items</p>
              </div>
            </div>

            <div className="dashboard-card" onClick={() => navigate('/admin/schedule')}>
              <div className="card-icon routes-icon">
                <i className="fas fa-route"></i>
              </div>
              <div className="card-content">
                <h3>Routes</h3>
                <p className="stat-count">{stats.routesCount}</p>
                <p className="stat-label">Active Routes</p>
              </div>
            </div>

            <div className="dashboard-card" onClick={() => navigate('/admin/schedule')}>
              <div className="card-icon vessels-icon">
                <i className="fas fa-ship"></i>
              </div>
              <div className="card-content">
                <h3>Vessels</h3>
                <p className="stat-count">{stats.vesselsCount}</p>
                <p className="stat-label">Active Vessels</p>
              </div>
            </div>

            <div className="dashboard-card" onClick={() => navigate('/admin/schedule')}>
              <div className="card-icon ports-icon">
                <i className="fas fa-anchor"></i>
              </div>
              <div className="card-content">
                <h3>Ports</h3>
                <p className="stat-count">{stats.portsCount}</p>
                <p className="stat-label">Listed Ports</p>
              </div>
            </div>

            <div className="dashboard-card" onClick={() => navigate('/admin/schedule')}>
              <div className="card-icon schedules-icon">
                <i className="fas fa-calendar-alt"></i>
              </div>
              <div className="card-content">
                <h3>Schedules</h3>
                <p className="stat-count">{stats.schedulesCount}</p>
                <p className="stat-label">Active Schedules</p>
              </div>
            </div>

            {/* <div className="dashboard-card">
              <div className="card-icon enquiries-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="card-content">
                <h3>Enquiries</h3>
                <p className="stat-count">{stats.enquiriesCount}</p>
                <p className="stat-label">Total Enquiries</p>
              </div>
            </div> */}
          </div>

          <div className="dashboard-sections">
            <div className="dashboard-section">
              <h2>Quick Actions</h2>
              <div className="quick-links-grid">
                <button onClick={() => navigate('/admin/equipment')} className="quick-link-btn">
                  Manage Equipment
                </button>
                <button onClick={() => navigate('/admin/schedule')} className="quick-link-btn">
                  Sailing Schedule
                </button>
                <button onClick={() => navigate('/admin/profile')} className="quick-link-btn">
                  Admin Profile
                </button>
                <button onClick={() => navigate('/inland-logistics')} className="quick-link-btn">
                  View Inland Logistics
                </button>
              </div>
            </div>

            <div className="dashboard-section">
              <h2>System Information</h2>
              <div className="system-info">
                <div className="info-item">
                  <span className="info-label">Server Status:</span>
                  <span className="info-value status-ok">Online</span>
                </div>
                <div className="info-item">
                  <span className="info-label">API Status:</span>
                  <span className="info-value status-ok">Connected</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Database:</span>
                  <span className="info-value status-ok">Operational</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Last Login:</span>
                  <span className="info-value">{new Date().toLocaleString()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;